/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react'

// export async function sendRequest(url: string | URL | Request, { arg }: { arg: any }) {
//     return fetch(url, {
//         method: 'PUT',
//         body: JSON.stringify(arg)
//     })
// }


export async function sendRequest(url: string | URL | Request, { arg }: { arg: any }): Promise<any> {
    return fetch(url, {
        method: 'PUT',
        headers: new Headers({'content-type': 'application/json'}),
        body: JSON.stringify(arg)
    }).then(res => res.json())
}


export const fetcher_no_cache = async ([url, body]: [RequestInfo | URL, Record<string, unknown>]): Promise<any> => {
    const res = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(body),
        cache: 'no-store'
    })
    return await res.json();
}


export default function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}